<template>
  <div class="l-main">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-10 col-md-offset-1">
          <h2 class="special-offers-page__lede">
            <contentful-text
              v-if="!isDesktop"
              :item="contentfulText('special-offers-page-lede')"
              :apply-markdown="false"
              :render-inline="false"
            />
            <contentful-text
              v-if="isDesktop"
              :item="contentfulText('special-offers-page-lede')"
              :apply-markdown="true"
              :render-inline="true"
            />
          </h2>
        </div>
      </div>
      <h3 class="special-offers-page__sublede">
        <contentful-text
          :item="contentfulText('special-offers-page-sublede')"
          :apply-markdown="true"
          :render-inline="true"
        />
      </h3>
      <div class="special-offers-page__brand-logo">
        <contentful-image
          :item="contentfulImage('special-offers-page-brand-logo')"
          class="responsive-img"
        />
      </div>
      <featured-special-offers :offers="specialOffersFeatured" />
      <special-offers
        :offers="specialOffers"
        :slot-number-offset="specialOffersFeatured.length"
      />
      <div class="special-offers-page__fine-print">
        <contentful-text :item="contentfulText('special-offers-page-fine-print')" />
      </div>
    </div>
  </div>
</template>

<script>
import FeaturedSpecialOffers from './components/FeaturedSpecialOffers'
import SpecialOffers from './components/SpecialOffers'
import ResponsiveBreakpointsMixin from '@Shared/mixins/responsive-breakpoints'

export default {
  name: 'HomeSpecialOffers',
  components: {
    FeaturedSpecialOffers,
    SpecialOffers
  },
  mixins: [
    ResponsiveBreakpointsMixin
  ],
  data () {
    return {
      content: window.pageData.homeSpecialOffers.pageContent,
      specialOffersFeatured: window.pageData.homeSpecialOffers.specialOffersFeatured,
      specialOffers: window.pageData.homeSpecialOffers.specialOffers
    }
  }
}
</script>

<style lang="scss" scoped>
.special-offers-page {
  &__lede {
    margin: 20px 0;
    padding: 0;
    text-align: center;
    font-size: 17px;
  }

  &__sublede {
    margin: 0 0 30px 0;
    padding: 0;
    font-family: $font-open-sans;
    text-align: center;
    font-weight: 700;
    font-size: 17px;
  }

  &__brand-logo {
    width: 100px;
    margin: 0 auto 40px auto;
  }

  &__fine-print {
    font-size: 11px;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__lede {
      font-size: 32px;
    }

    &__sublede {
      font-size: 28px;
    }

    &__brand-logo {
      width: 140px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/default/home/special-offers/App.vue